import { generalServiceV1API } from '@/store/api-instance'
import { IContractsResponse } from '@/store/modules/contracts/interfaces/api/IContractsResponse'
import { AxiosResponse } from 'axios'

export const contractsAPI = {
  async fetchContracts (): Promise<IContractsResponse> {
    const response: AxiosResponse = await generalServiceV1API.get<IContractsResponse>('contracts')
    return response.data
  }
}
